export * from '@primeuix/themes/lara/inputtext';
export { default } from '@primeuix/themes/lara/inputtext';
